import PropTypes from 'prop-types';
import React, { useState } from 'react';
import CustomModal from 'commons/modal/CustomModal';
import ConfirmationModal from 'commons/modal/ConfirmationModal';
import { Grid } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';

export default function AmbianceModal(props) {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const produits = [];

  props.selectedRow.ambPtr.forEach(elem => {
    if (elem !== "") {
      let temp = { produits: elem };

      produits.push(temp);
    }
  });

  return (
    <div>
      <CustomModal
        width={'45%'}
        title={props.selectedRow.ambDescr}
        onClose={props.toggleDialog}
        body={
          <div>
            <div className='inline' style={{ marginBottom: '5px' }}>
              <div></div>
              <div className="me-auto">
                {props.selectedRow !== undefined && (
                  <Button className="blueButton" onClick={() => setDeleteModalVisible(true)}>
                    {`Retirer l'ambiance`}
                  </Button>
                )}
              </div>
            </div>
            <Grid data={produits}
            ></Grid>
            {deleteModalVisible && (
              <ConfirmationModal
                text={`Retirer l'ambiance ?`}
                onClose={() => {
                  setDeleteModalVisible(false);
                }}
                onConfirm={() => {
                  setDeleteModalVisible(false);
                  props.remove();
                }} />
            )}
          </div>
        }
      />
    </div>
  );
}

AmbianceModal.propTypes = {
  selectedRow: PropTypes.any,
  remove: PropTypes.func,
  toggleDialog: PropTypes.func,
};
